module.exports = __webpack_public_path__ + "static/media/points-history-icon.fdf2313b.svg";